import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Draganddrop from './Draganddrop'
import AwsConfig from '../../Config/AwsConfig'
import CastTeUi from './CastTeUi'

const CastUi = props => {
  const {
    truevalue,
    sendtruevalue,
    sendEditmode,
    // castas,
    sendcasten,
    editmode,
    sendCastTe,
    // castaste,
    sendinputdata,
    sendcastCharacterTeValue,
    sendcastCharacterEnvalue,
    inputdata,
    casten,
    CastTe,
    castCharacterEn,
    castcharte,
    sendcastCharacterEn,
    sendcastcharte,
    sendcastenvalue,
    sendCastTeValue,
    editData,
    modeUrl,
    active,
    searchTrue,
    handleChangeFilter,
    castenvalue,
    finalcastname,
    handlechangete,
    handlechange,
    handleActiveChange,
    handlechangecharacterte,
    castCharacterTeValue,
    handlechangecharacter,
    castCharacterEnvalue,
    CastTeValue,
    selectsuggestion,
    SubmitCast,
  } = props
  return (
    <div>
      <Row>
        <Col md={6} xs={6}>
          <div>
            <div>
              <label>
                {' '}
                Cast_En:<div className='mandatory'>*</div>
              </label>
              <Draganddrop
                truevalue={truevalue}
                sendtruevalue={sendtruevalue}
                sendEditmode={sendEditmode}
                castas={inputdata.Moviecast}
                sendcasten={sendcasten}
                editmode={editmode}
                sendCastTe={sendCastTe}
                castaste={inputdata.Moviecastte}
                sendinputdata={sendinputdata}
                sendcastCharacterTeValue={sendcastCharacterTeValue}
                sendcastCharacterEnvalue={sendcastCharacterEnvalue}
                inputdata={inputdata}
                casten={casten}
                CastTe={CastTe}
                castCharacterEn={castCharacterEn}
                castcharte={castcharte}
                sendcastCharacterEn={sendcastCharacterEn}
                sendcastcharte={sendcastcharte}
                sendcastenvalue={sendcastenvalue}
                sendCastTeValue={sendCastTeValue}
                editData={editData}
                modeUrl={modeUrl}
                active={active}
              />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <div style={{ width: '100%' }}>
                {searchTrue && (
                  <input
                    onChange={event => handleChangeFilter(event.target.value)}
                    value={castenvalue}
                    className='form-control'
                    style={{ width: '100%' }}
                  />
                )}
                {finalcastname.length >= 1 && searchTrue && (
                  <div
                    className='searchfield'
                    style={{
                      width: '200%',
                      position: 'relative',
                      zIndex: '1',
                    }}
                  >
                    {searchTrue &&
                      finalcastname.map((castName, castIndex) => {
                        let { posterURL } = castName
                        if (posterURL === 'none' || posterURL === '') {
                          posterURL =
                            AwsConfig.movieCdnUrl +
                            AwsConfig.avatharPath +
                            AwsConfig.personStaticImage
                        } else if (posterURL && !posterURL.includes(AwsConfig.movieCdnUrl)) {
                          posterURL = AwsConfig.movieCdnUrl + posterURL
                        }

                        return (
                          <div
                            key={castIndex}
                            onClick={event => selectsuggestion(event, castIndex)}
                            style={{
                              width: '100%',
                              height: '3.5rem',
                              marginRight: '10px',
                              boxSizing: 'unset',
                            }}
                          >
                            <ul
                              className='list-group list-group-flush'
                              style={{ height: '3.5rem', paddingTop: '0px', paddingBottom: '0px' }}
                            >
                              <li
                                className='list-group-item'
                                style={{ marginRight: 'auto', width: '100%', height: '3.5rem' }}
                              >
                                <div
                                  className='media d-flex justify-content-center align-items-center'
                                  style={{ gap: '10px', marginRight: 'auto' }}
                                >
                                  {castName &&
                                  castName.label &&
                                  castName.label.includes('Create') ? (
                                    ''
                                  ) : (
                                    <img
                                      style={{ width: '2rem', height: '2rem', marginRight: 'auto' }}
                                      className='align-self-center'
                                      src={posterURL}
                                    />
                                  )}
                                  <div
                                    className='media-body align-self-center mr-4'
                                    style={{ display: 'flex', flexWrap: 'wrap', fontSize: '10px' }}
                                  >
                                    {castIndex === 0 ? (
                                      <label
                                        style={{
                                          position: 'relative',
                                          left: '140px',
                                        }}
                                      >
                                        {castName.label}
                                      </label>
                                    ) : (
                                      <div>
                                        <span>
                                          <b>Name:</b>
                                          <span style={{ fontSize: '10px' }}>
                                            {castName.label}
                                          </span>{' '}
                                          {castName.roles?.length > 0
                                            ? `(${[...new Set(castName.roles)]
                                                .slice(0, Math.min(castName.roles.length, 5))
                                                .toString()})`
                                            : ''}
                                        </span>
                                        <br />
                                        <span>{castName.personWikiURL}</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </li>
                              <hr style={{ background: 'black', color: 'black' }} />
                            </ul>
                          </div>
                        )
                      })}
                  </div>
                )}
              </div>

              {!searchTrue && (
                <input
                  onChange={event => handlechange(event.target.value)}
                  className='form-control'
                  value={castenvalue}
                  style={{ width: '68%' }}
                />
              )}
              <label>as</label>
              <input
                onChange={event => handlechangecharacter(event.target.value)}
                className='form-control'
                value={castCharacterEnvalue}
                style={{ width: '50%' }}
              />
            </div>
          </div>
          {modeUrl ? (
            <div style={{ position: 'relative', bottom: '30px' }}>
              <div className='tinput'>
                <div
                  className='currentlyactive-style'
                  style={{ display: 'flex', gap: '10px', position: 'relative', top: '30px' }}
                >
                  <input
                    id='c11'
                    type='checkbox'
                    name='currently active'
                    style={{ width: '1.875rem' }}
                    // className='form-control'
                    checked={active.cast === 'TRUE'}
                    onChange={event => handleActiveChange(event, 'cast')}
                  />
                  <label htmlFor='c11'>OK</label> <br></br>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </Col>
        <Col md={6} xs={6}>
          <CastTeUi
            inputdata={inputdata}
            handlechangete={handlechangete}
            CastTeValue={CastTeValue}
            castCharacterTeValue={castCharacterTeValue}
            handlechangecharacterte={handlechangecharacterte}
          />
          <button
            style={{ float: 'right' }}
            type='button'
            disabled={!(castenvalue && CastTeValue)}
            className='btn btn-primary'
            onClick={SubmitCast}
          >
            ok{' '}
          </button>
        </Col>
      </Row>
    </div>
  )
}

export default CastUi
